export { Depths } from '@fluentui/theme';
